import React, { } from 'react'
import { useTranslation } from 'react-i18next'
import MainTable from '../../../components/Basic/MainTable'
import { Loading3QuartersOutlined } from '@ant-design/icons'

function SegmentTable (props) {
  const { segmentParams, segmentKey } = props
  const { fetchParams } = segmentParams
  const { t: ln_t } = useTranslation()

  const getSegment = async () => ({ status: 200, data: fetchParams?.data || [] })
  const segmentColumns = [
    { title: ln_t('util.id'), dataIndex: 'id' },
    { title: ln_t('util.name'), dataIndex: segmentKey, render: e => e?.name || '' },
    { title: ln_t('segment.activity'), dataIndex: segmentKey, render: e => `${e?.interval || 0} ${ln_t('util.days')}` },
    { title: ln_t('segment.quantity'), dataIndex: 'count', render: e => e === undefined ? <Loading3QuartersOutlined spin /> : e }
  ]

  return (
    <MainTable
      style={{ paddingTop: '16px' }}
      columns={segmentColumns}
      rowKey="id"
      apiFunc={getSegment}
      params={segmentParams}
    />
  )
}

export default SegmentTable
